import { createSelector } from 'reselect';
import { getPageEep, getPageData } from 'src/universal/redux/page';
import { getPznOffersEepByShortName } from 'src/universal/redux/pznData';
import { processSummitHeroData } from '../utils/index.js';

export const getStaticDataForProspectHero = createSelector(
  getPageData,
  ({ prospectTabbedHero }) => {
    if (
      !Array.isArray(prospectTabbedHero?.heroContent) ||
      !Array.isArray(prospectTabbedHero?.heroContent[0].content)
    ) {
      return null;
    }

    return prospectTabbedHero;
  }
);

export const getProspectHeroData = (eep, summitData) =>
  createSelector(
    [getPageEep(eep), getPznOffersEepByShortName],
    (pageEep, eepHash) => {
      return {
        summitHeroData: processSummitHeroData(summitData, pageEep, eepHash)
      };
    }
  );
